// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"3e0a53fc","205":"593a8825","287":"93b63801","535":"6e2de596","545":"853f70a8","754":"259890f3","895":"399a0dbd","934":"089e493d"}[chunkId] + ".chunk.js";
};